
<div class="flex-style">
    <h3>Search Auctions</h3> 
    <i class="fa fa-info-circle left-margin auction-info" (mouseover)="informationDialog.show($event)"
    (mouseout)="informationDialog.hide($event)"></i>
    <button pButton  type="submit" label="Change Log" (click)="showChangeLogDialog()" class="changeLogButton"></button>
  </div>
  <form name="auctionForm" [formGroup]="auctionForm" (ngSubmit) = "onSubmit()">
    <div class="form-wrapper">
      <div>
        <div class="form-group">
            <input type="text" pInputText placeholder="Loan #" formControlName="loan" value="" (input)="clearValidationForReservePrice()" class="form-control" />  
        </div>
      </div>
      <div class="marginClass">
        <div class="form-group">
            <p-dropdown 
                [options]="reservePriceRange" 
                [(ngModel)]="reservePriceRangeSelected" 
                (onChange)="setReversePriceparams()" 
                formControlName="ReservepriceOptions"
                class="form-control selectDropDown selectDropDownLabel">
            </p-dropdown>  
        </div>
      </div>
      <div class="marginClass" *ngIf="setEqualsCriteria">  
        <input  pInputText placeholder="Reserve Price"  [(ngModel)]="exactReservePrice" pattern="^[0-9]\d*(\.\d*)?$"
         formControlName="exactReservePriceForm"  class="form-control" />
        <div class="invalid-feedback">
            <div *ngIf="auctionForm.get('exactReservePriceForm').touched && auctionForm.get('exactReservePriceForm').invalid"  class="error-class">Please enter valid number/decimals without any special characters</div>
        </div>
       
      </div>
      <div  class="marginClass" *ngIf="setRangeCriteria">
        <div class="form-group" style="display: flex">
          <div>
            <input  pInputText placeholder="Min Reserve Price"  [(ngModel)]="minReservePrice" pattern="^[0-9]\d*(\.\d*)?$"
              formControlName="minReservePriceForm" (input)="validateReservePriceRange($event)" class="form-control"/> 
              <div *ngIf="auctionForm.get('minReservePriceForm').touched && auctionForm.get('maxReservePriceForm').touched && rangeError" class="error-class">
                Enter the correct price range 
              </div>
             <div *ngIf="(auctionForm.get('minReservePriceForm').touched && auctionForm.get('minReservePriceForm').invalid) || 
             (auctionForm.get('maxReservePriceForm').touched && auctionForm.get('maxReservePriceForm').invalid)" class="error-class">
                <div *ngIf="!rangeError">
                  Please enter valid number/decimals without any special characters
                </div>
             </div>
          </div>
          <div class="marginHyphen">&nbsp; &ndash; &nbsp; </div>
          <div>
              <input  pInputText placeholder="Max Reserve Price"  [(ngModel)]="maxReservePrice" pattern="^[1-9]\d*(\.\d*)?$"
              formControlName="maxReservePriceForm"  (input)="validateReservePriceRange($event)" class="form-control"/>
          </div>
        </div>
      </div>
      <div class="marginClass" >
          <div class="form-group">
              <button pButton [disabled]="!auctionForm.valid || rangeError || disableSubmit" type="submit" label="{{searchLabel}}" class="button-height"></button>
          </div>
      </div>
    </div>
  </form>
  
    <div *ngIf="data">
      <div class="align-right text-bold" *ngIf="!loading">{{totalRecords}} record(s) found</div> 
      <p-table #dt [value]="data"
        [columns]="cols"
        autoLayout=true 
        [paginator]="true" 
        [loading]="loading" 
        [rows]="10"
        [totalRecords]="totalRecords" 
        dataKey="propertyId"
        [expandedRowKeys]="expandedRows"
        rowExpandMode="multiple"
        (onLazyLoad)="onPage($event)"
        [lazy]="true"
        [lazyLoadOnInit] = "false"
        [resetPageOnSort] = "false">
  
        <ng-template pTemplate="header">
            <tr>
                <th style="width: 3em"></th>
                <ng-container *ngFor="let col of cols">
                  <th *ngIf="col.showInHeader" class="center-align">
                    {{col.header}}
                  </th>
                </ng-container>
            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
           <tr *ngIf="!loading && data.length === 0">
               <td [attr.colspan]="10" class="center-align">No records found</td> 
          </tr>
        </ng-template>
        <i class="pi pi-spin pi-spinner" style="font-size: 3em" *ngIf="loading"></i>
        <ng-template pTemplate="body" let-rowData let-rowIndex="rowIndex" let-columns="columns" let-expanded="expanded">
          <tr *ngIf="!rowData.loanDataAvailable">
              <td>
                <i class="fas fa-plus-square"></i>
              </td>
              <td class="center-align">{{rowData.loan}}</td>
              <td colspan="7" class="center-align">No data available</td>
          </tr>
          <tr *ngIf="rowData.loanDataAvailable">
            <td>
                <a href="#" (click)="disableForm(rowData)"  [pRowToggler]="rowData" > 
                    <i [ngClass]="expanded ? 'fas fa-minus-square' : 'fas fa-plus-square'"></i>
                </a>
            </td>
            <ng-container *ngFor="let col of columns">
              <td *ngIf="col.showInHeader && col.field !='edit'" class="center-align">
                {{rowData[col.field]}}
              </td>
              <td *ngIf="col.showInHeader && col.field =='edit'" class="center-align">
                <button pbutton 
                  [disabled]="!rowData.canEditReservePrice || rowData.requestStatus == 'Request Processing'|| rowData.updateRunning" 
                  
                  (click)="enableForm(rowData,expanded)" 
                  class="edit-icon">
                    <i class="pi pi-pencil edit-record-icon"></i>
                </button>
                <button type="button"  pbutton (click)="refreshData(rowData)" [disabled]="rowData.refreshState" class="edit-icon">
                  <i class="pi pi-refresh refresh-icon" *ngIf="!rowData.refreshState"></i>
                  <i class="pi pi-spin pi-spinner" style="font-size: 1.5em" *ngIf="rowData.refreshState"></i>
                </button>
              </td>
            </ng-container>
          </tr>
        </ng-template>
        <ng-template pTemplate="rowexpansion" let-rowData  let-columns="columns" let-rowIndex="rowIndex"> 
            <tr>
              <td width="50%" colspan="5">
                  <div class="column-align">
                      <div class="ui-g-6 align-right">
                          List Start Date:
                        </div>
                        <div class="ui-g-6 align-left no-top-padding">
                            {{rowData.listStartDate}}
                        </div>
                  </div>
                  <div class="column-align">
                      <div class="ui-g-6 align-right">
                          List End Date:
                      </div>
                      <div class="ui-g-6 align-left no-top-padding">
                          {{rowData.listEndDate}}
                      </div>
                  </div>
                  <div class="column-align">
                      <div class="ui-g-6 align-right">
                          Bidders (#):
                      </div>
                      <div class="ui-g-6 align-left no-top-padding">
                          {{rowData.bidders}}
                      </div>
                  </div>
                  <div class="column-align">
                      <div class="ui-g-6 align-right">
                          Views (#):
                      </div>
                      <div class="ui-g-6 align-left no-top-padding">
                        {{rowData.views}}
                      </div>
                  </div>
                  <div class="column-align">
                    <div class="ui-g-6 align-right">
                        Saves (#):
                    </div>
                    <div class="ui-g-6 align-left no-top-padding">
                      {{rowData.views}}
                    </div>
                </div>
                <div class="column-align">
                  <div class="ui-g-6 align-right">
                      Reserve Price Changed By:
                  </div>
                  <div class="ui-g-6 align-left no-top-padding">
                    {{rowData.reservePriceChangedBy}}
                  </div>
                </div>
                <div class="column-align">
                  <div class="ui-g-6 align-right">&nbsp;</div>
                  <div class="ui-g-6 align-left no-top-padding">&nbsp;</div>
                </div>
              </td>
              <td width="50%" colspan="4">
                  <div class="formSection">
                    <div style="width:70%">
                      <form name="reservePriceUpdateForm-{{rowData.propertyId}}" [formGroup]="getReservePriceUpdateForm(rowData.propertyId)" (ngSubmit) = "updateReservePriceForm(rowData)"> 
                          <div class="column-align">
                              <div class="ui-g-6 align-right">
                                  Initial Reserve Price ($):
                              </div>
                              <div class="ui-g-6 no-top-padding">
                                  {{rowData.initialReservePrice}}
                              </div>
                          </div>
                          <div class="column-align">
                            <div class="ui-g-6 align-right">
                                % of Initial Reserve Price:
                            </div>
                            <div class="ui-g-6 no-top-padding">
                              <input type="number" formControlName="perInitialReservePrice" 
                                  [value]="rowData.perInitialReservePrice ? (rowData.perInitialReservePrice).toFixed(2) : rowData.perInitialReservePrice"  
                                  [ngClass]="rowData.newReservePrice < rowData.startbid ? 'redFontClass' : 'greenFontClass'"
                                  /> 
                            </div>
                          </div>
                          <div class="column-align">
                            <div class="ui-g-6 align-right" >
                                  Reserve Reduction %: 
                            </div>
                            <div class="ui-g-6 no-top-padding">
                              <input pattern="^[0-9]\d*(\.\d*)?$"  type="text"
                                  (keypress) ="numbersOnly($event,rowData)"
                                  formControlName="reservePriceReduction"
                                  value="{{rowData.reservePriceReduction}}" class="inputStyle input-width" 
                                  [readonly]="!rowData.edit == true"
                                  [ngClass]="!rowData.edit ? 'readOnlyClass' : ''"
                                  [(ngModel)]="rowData.reservePriceReduction"
                                  autocomplete="off"
                                  (input)="calculatefields(rowData)"  />  
                                  <i class="fa fa-info-circle info-icon-FontSize left-margin" 
                                    pTooltip="Cannot be Reduced below Starting Bid {{rowData.startbid}}"></i>
                                  <span *ngIf="rowData.reservePriceReductionError && rowData.reservePriceReduction != 0" class="percentageReductionError">
                                    % should not be more then 100
                                  </span>
                                  <span *ngIf="rowData.reservePriceReductionError && rowData.reservePriceReduction == 0" class="percentageReductionError">
                                    % should not be 0
                                  </span>
                            </div>
                          </div>
                          <div class="column-align">
                            <div class="ui-g-6 align-right"> 
                                New Reserve Price ($):
                            </div>
                            <div class="ui-g-6 no-top-padding"> 
                                <input type="number" formControlName="newReservePrice"  
                                  [value]="rowData.newReservePrice ? (rowData.newReservePrice).toFixed(2) : rowData.newReservePrice" 
                                  [ngClass]="rowData.newReservePrice < rowData.startbid ? ' redFontClass' : ' greenFontClass'"  
                                  /> 
                            </div>
                          </div>
                          <div class="column-align">
                            <div class="ui-g-6 align-right">
                                Date/Time of Change:
                            </div>
                            <div class="ui-g-6 no-top-padding">
                                {{rowData.reservePriceChangedDate}}
                            </div>
                          </div>
                          <div class="column-align">
                            <div class="ui-g-6 align-right">
                                Message:
                            </div>
                            <div class="ui-g-6 no-top-padding">
                              <span *ngIf="rowData.requestStatus == 'Request Failed'" class="messageColorRed">
                                {{rowData.requestStatus}} {{rowData.errorMessage}}
                              </span>
                              <span *ngIf="rowData.requestStatus == 'Request Incomplete' || rowData.requestStatus == 'Request Processing'" class="messageColorRed">
                                {{rowData.requestStatus}}
                              </span>
                              <span *ngIf="rowData.requestStatus == 'Request Complete'" class="messageColorGreen">
                                {{rowData.requestStatus}}
                              </span>
                            </div>
                          </div>
                          <div class="form-group buttonSection"  *ngIf="rowData.edit == true">
                            <button  pButton 
                              [pRowToggler]="rowData"
                              label="Cancel"
                              (click)="disableForm(rowData)"
                              class="ui-button-secondary"                             
                              [disabled]="rowData.updateRunning"
                              *ngIf="!(rowData.requestStatus == 'Request Processing')" >
                            </button>
                            <button  pButton 
                              [disabled]="!getReservePriceUpdateForm(rowData.propertyId).valid || rowData.newReservePrice < rowData.startbid || rowData.updateRunning || rowData.reservePriceReductionError" 
                              type="submit"  
                              class="buttonCancel"
                              label="{{rowData.updateRunning ? 'Saving..' : 'Save'}}"
                              *ngIf="!(rowData.requestStatus == 'Request Processing')" >
                            </button>
                          </div>
                          <div class="emptyDiv"  *ngIf="rowData.edit == false"></div>
                        </form>
                    </div>
                  </div>
              </td>
            </tr>
        </ng-template>
      </p-table>
    </div>

    <p-overlayPanel #informationDialog class="no-Flicker" [dismissable]="true" styleClass="dark-background">
      <div>
        <ul>
          <li>Search Auction allows the Partner Type to update the Reserve Price on a property while the auction is in
            <br>progress. The Partner Type can search by a single Loan Number, a specific Reserve Price or Reserve Price
            Range.
            <ul>
              <li>If results matching the search criteria are returned expanding the UI allows a detailed view of <br> the
                auction data details.</li>
              <li>Clicking the edit pencil allows the Partner Type to enter the ‘Reserve Reduction %’ and this auto <br>
                calculates the ‘New Reserve Price ($)’ and the ‘% of Initial Reserve Price’ based on reduction being <br>
                applied. The ‘Reserve Reduction %’ has validation logic and if satisfied the calculated values will <br>
                display in green font and the ‘Save’ button enables. If ‘Reserve Reduction %’ fails the validation <br>logic
                then an error message is displayed and the ‘Save’ button is disabled.</li>
            </ul>
          </li>
          <li>
            Clicking the ‘Refresh’ displays a circling image on the UI and the setting is delayed for 50 seconds before it
            can be clicked again.
          </li>
          <li>Clicking ‘Save’ displays ‘Request in Process’ and updates the Change Log with the same. If the request
            fails<br> then the record in the Change Log will update and display ‘Request Incomplete’. If the request was
            <br> successful then the Change Log displays ‘Request Updated Successfully. </li>
    
        </ul>
      </div>
    </p-overlayPanel>
  
    <p-overlayPanel #ReserveReductionInfo class="no-Flicker" [dismissable]="true" styleClass="dark-background">
      Cannot be reduced below Starting Bid: 
    </p-overlayPanel>